// extracted by mini-css-extract-plugin
export var btnDefault = "CustomButton-module--btnDefault--ecf7c";
export var btnIcon = "CustomButton-module--btnIcon--44411";
export var btnLarge = "CustomButton-module--btnLarge--8ee5f";
export var btnSmall = "CustomButton-module--btnSmall--a7788";
export var btnText = "CustomButton-module--btnText--6fe06";
export var ctaBtn = "CustomButton-module--ctaBtn--01362";
export var fitContent = "CustomButton-module--fitContent--82386";
export var ghostBtn = "CustomButton-module--ghostBtn--39f60";
export var iconBtnDefault = "CustomButton-module--iconBtnDefault--8c81d";
export var iconBtnLarge = "CustomButton-module--iconBtnLarge--bdce5";
export var iconBtnSmall = "CustomButton-module--iconBtnSmall--0d228";
export var lmsScrollbar = "CustomButton-module--lms-scrollbar--7b372";
export var outlineDarkBtn = "CustomButton-module--outlineDarkBtn--87a0c";
export var outlineLiteBtn = "CustomButton-module--outlineLiteBtn--9db6a";
export var primaryBtn = "CustomButton-module--primaryBtn--70c0b";
export var secondaryBtn = "CustomButton-module--secondaryBtn--dea39";
export var spaceLeft = "CustomButton-module--spaceLeft--4c0d7";